// savings-balance.validator.ts
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import {
  CustomValidators,
  NameIsFirstAndLastValidatorConfig,
} from '@finxone-platform/shared/sys-config-types';

export class NameIsFirstAndLastValidator {
  createSyncFromConfig(config: NameIsFirstAndLastValidatorConfig): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      // Skip validation if control is empty
      if (!control.value) {
        return null;
      }

      // Check if value can be split into first and last name by space
      const nameParts = control.value.trim().split(' ');

      if (nameParts.length < 2) {
        const errors: ValidationErrors = {};
        errors['invalidName'] = config.defaultErrorMessage || 'Name must include both first and last names';
        return errors;
      }

      return null; // Valid
    };
  }
}

// Example configuration
export const NAME_IS_FIRST_AND_LAST_VALIDATION_CONFIG: NameIsFirstAndLastValidatorConfig = {
  type: CustomValidators.NAME_IS_FIRST_AND_LAST_VALIDATOR,
};
